// extracted by mini-css-extract-plugin
export default {"container":"SummaryRow_container__9+wXV","value-container":"SummaryRow_value-container__mnTAq","value-item":"SummaryRow_value-item__CpppC"};